import React from 'react'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { DashboardV2InvestmentView } from '../dashboard-v2.types'
import { formatAxisDollar, truncateLabel } from '../dashboard-v2.utils'

type InvestmentsTabsProps = {
  view: DashboardV2InvestmentView
  onChange: (view: DashboardV2InvestmentView) => void
  statusData: { name: string; value: number; color: string }[]
  snapshotData: { name: string; invested: number; current: number }[]
}

export const InvestmentsTabs: React.FC<InvestmentsTabsProps> = ({
  view,
  onChange,
  statusData,
  snapshotData,
}) => {
  return (
    <article className='dashboard-v2__mini-card'>
      <div className='card-head'>
        <h3>Your Investments</h3>
        <div className='investment-tabs'>
          <button
            type='button'
            className={view === 'snapshot' ? 'active' : ''}
            onClick={() => onChange('snapshot')}
          >
            Snapshot
          </button>
          <button
            type='button'
            className={view === 'status' ? 'active' : ''}
            onClick={() => onChange('status')}
          >
            Status Split
          </button>
        </div>
      </div>
      {view === 'status' && (
        <div className='chart-wrap'>
          <ResponsiveContainer width='100%' height={250}>
            <BarChart data={statusData}>
              <CartesianGrid strokeDasharray='3 3' vertical={false} />
              <XAxis dataKey='name' />
              <YAxis tickFormatter={formatAxisDollar} width={68} />
              <Tooltip />
              <Bar dataKey='value' radius={[6, 6, 0, 0]}>
                {statusData.map((item) => (
                  <Cell key={item.name} fill={item.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
      {view === 'snapshot' && (
        <div className='chart-wrap'>
          <ResponsiveContainer width='100%' height={290}>
            <BarChart data={snapshotData} margin={{ top: 8, right: 12, left: 16, bottom: 24 }}>
              <CartesianGrid strokeDasharray='3 3' vertical={false} />
              <XAxis
                dataKey='name'
                interval={0}
                angle={-15}
                textAnchor='end'
                height={72}
                tickFormatter={(value) => truncateLabel(value, 26)}
              />
              <YAxis tickFormatter={formatAxisDollar} width={68} />
              <Tooltip
                formatter={(value, name) => [
                  formatAxisDollar(Number(value || 0)),
                  name === 'invested' ? 'Invested' : 'Current',
                ]}
              />
              <Bar dataKey='invested' fill='#0B4E9D' radius={[4, 4, 0, 0]} />
              <Bar dataKey='current' fill='#2CA46F' radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </article>
  )
}
